/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CarrierShareDeliveryNoteAccessRequest } from '../../models/carrier-share-delivery-note-access-request';
import { KeyType } from '../../models/key-type';

export interface ShareDeliveryNotesRights$Params {
  organizationSiteKey: KeyType;
      body: CarrierShareDeliveryNoteAccessRequest
}

export function shareDeliveryNotesRights(http: HttpClient, rootUrl: string, params: ShareDeliveryNotesRights$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, shareDeliveryNotesRights.PATH, 'post');
  if (params) {
    rb.path('organizationSiteKey', params.organizationSiteKey, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

shareDeliveryNotesRights.PATH = '/organization-sites/{organizationSiteKey}/carrier/delivery-notes/share-rights';
